<form
  class="newsletter container"
  [formGroup]="form"
  (ngSubmit)="send()"
>
  <div class="newsletter_container_input">
    <div class="list__header">
      <p>Newsletter</p>
    </div>

    <div class="field_input">
      <input
        class="newsletter_input"
        formControlName="contact_email"

        placeholder="Email"
        type="email"
        id="email"
      />
      <button
        placeholder="Email"
        class="newsletter_button btn btn--primary event"
        type="submit"
      >
        Suscribirse
      </button>
    </div>
  </div>
</form>

<ng-container *ngIf="step == 2">
  <p class="newsletter_success">
    ¡Gracias por suscribirte! A partir de ahora recibirás nuestras
    novedades en tu email
  </p>
</ng-container>

<p class="newsletter_error" *ngIf="errorMessage">
  {{ errorMessage }}
</p>
